import React, {HTMLAttributes, RefObject, TdHTMLAttributes, useCallback, useRef} from "react";
import {Table, TableProps} from "antd";
import {Key} from "antd/es/table/interface";
import {AnyObject} from "antd/es/_util/type";
import {TableRef} from "antd/lib/table";

export const TableHeaderCell = ({children, ...rest}: any) => (<td {...rest}>
  <span className={"table-header"}>{children}</span>
</td>);
const header = {
  cell: TableHeaderCell,
};

export interface CustomTableProps<T> extends TableProps<T> {
  rowKey?: keyof T;
}

const CHECKBOX_CELL_WIDTH = 40;
export const CustomTable = <T extends AnyObject = AnyObject>({
                                                               children, components, rowSelection, // selectedRowKeys,
                                                               onRow, rowKey, ...rest
                                                             }: CustomTableProps<T>) => {
  const selectedRowKeyRef = useRef(rowSelection?.selectedRowKeys || []);
  const selectedRowRef = useRef<T[]>([]);
  const tableRef = useRef<TableRef>();
  
  const handleSelect = useCallback((keys: Array<Key>, rows: T[]) => {
    selectedRowKeyRef.current = keys;
    selectedRowRef.current = rows;
    if (!!rowSelection?.onChange) rowSelection.onChange(keys, rows, {type: "multiple"});
  }, [rowSelection],);
  
  const handleClickOutsideCheckBox = useCallback((record: T, value: boolean) => {
    const key = rowKey ? record[rowKey] : record["key"];
    if (value) {
      selectedRowKeyRef.current = selectedRowKeyRef.current.filter((selectedKey) => selectedKey !== key);
      selectedRowRef.current = selectedRowRef.current.filter((selectedRow) => selectedRow !== record);
    }
    else {
      selectedRowKeyRef.current = [...selectedRowKeyRef.current, key];
      selectedRowRef.current = [...selectedRowRef.current, record];
    }
    console.log("handleClickOutsideCheckBox", key, value, selectedRowKeyRef.current);
    handleSelect(selectedRowKeyRef.current, selectedRowRef.current);
  }, [handleSelect, rowKey],);
  
  const handleClickRow = useCallback((record: T, rowIndex?: number) => {
    let listeners: HTMLAttributes<any> & TdHTMLAttributes<any> = {};
    if (onRow) {
      listeners = onRow(record, rowIndex);
    }
    const {onClick, ...rest} = listeners;
    return {
      onClick: (event: React.MouseEvent<HTMLElement>) => {
        const tableX = tableRef.current ? tableRef.current.nativeElement.getBoundingClientRect().x : 100;
        const eventX = event.nativeEvent.x;
        console.log("handleClickRow", eventX - tableX, tableX, eventX);
        if (rowSelection?.onChange && eventX - tableX <= CHECKBOX_CELL_WIDTH) {
          handleClickOutsideCheckBox(record, selectedRowRef.current.includes(record));
        }
        else if (onClick) onClick(event);
      }, ...rest,
    };
  }, [handleClickOutsideCheckBox, onRow, rowSelection?.onChange],);
  
  return (<Table<T>
    ref={tableRef as RefObject<TableRef>}
    components={{header, ...components}}
    rowKey={rowKey}
    onRow={handleClickRow}
    rowSelection={rowSelection ? {
      onChange: handleSelect, preserveSelectedRowKeys: false, selectedRowKeys: rowSelection?.selectedRowKeys
    } : undefined}
    {...rest}
  />);
};
